//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('price', {
//        templateUrl: 'views/components/views/price/price.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'priceService', 'economyService', function ($stateParams, stateService, utilityService, translateService, modalService, priceService, economyService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let priceGrpKeyno = $stateParams.pricegrp_keyno;
//            let priceKeyno = $stateParams.price_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                priceKeyno: priceKeyno,
//                edit: {},
//                selectListPrices: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//		    // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await priceService.getPrice({
//                    pricegrp_keyno: priceGrpKeyno,
//                    price_keyno: priceKeyno
//                }))[0];
//            }

//            async function loadPrices() {
//                vm.model.selectListPrices = await economyService.listPrices();
//            }
            
//            function retrievePriceList() {
//                if (utilityService.validateParmsValue(vm.model.edit.pricelist_id) !== true) return;

//                return economyService.getPriceList({ pricelist_id: vm.model.edit.pricelist_id }).then((response) => {
//                    vm.model.edit.pricelist_valuta_id = response[0].pricelist_valuta_id;
//                    vm.model.edit.tax_name = response[0].tax_name;
//                });
//            }

//		    // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'pricelist_id':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.pricelist_id) !== true) return;

//                        vm.model.edit.pricelist_id = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.pricelist_id) !== true) return;

//                        retrievePriceList();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                priceService.saveObj(vm.model.edit).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: (dialogItself) => {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    priceService.deleteItem(vm.model.edit).then(() => {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, () => {
//                        vm.model.lockedDelete = false;
//                    });
//                }, () => {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadPrices();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
